import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from '../shared/shared.module';
import { LoadingStateModule, StatsCardModule } from '@seniorsistemas/angular-components';
import { SStatsCardEmployeeCourseComponent } from './s-stats-card-employee-course.component';
import { SStatsCardEmployeeCourseService } from './s-stats-card-employee-course.service';

@NgModule({
    imports: [
        CommonModule,
        StatsCardModule,
        HttpClientModule,
        SharedModule,
        LoadingStateModule
    ],
    declarations: [SStatsCardEmployeeCourseComponent],
    providers: [SStatsCardEmployeeCourseService],
    exports: [SStatsCardEmployeeCourseComponent]
})
export class SStatsCardEmployeeCourseModule { }
